import React, { FC, useMemo } from 'react';

interface INotificationContainer {
  children: React.ReactElement;
  withNotification: boolean;
}

const NotificationContainer: FC<INotificationContainer> = ({ children, withNotification }) => {
  return useMemo(() => {
    if (withNotification) {
      return (
        <div className="with-notification-wrapper">
          {children}
          <span className="red-dot" />
        </div>
      );
    }

    return children;
  }, [children, withNotification]);
};

export default NotificationContainer;
